<template>
    <meetings :meetings="list"></meetings>
</template>

<script>
export default {
    mounted() {},
    created() {},
    props: ["meetings"],
    data() {
        return {};
    },
    computed: {
        list() {
            var self = this;
            try {
                if (this.meetings) {
                    return this.meetings.filter(function (u) {
                        return u.status == "future";
                    });
                }
            } catch (error) {} //
            return this.meetings;
        },
    },
};
</script>
